import { Button, showSuccessToast } from '@bpinternal/ui-kit-next'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft, Plus } from 'lucide-react'
import { Boundary, Page } from '~/components'
import { EditableTextField } from '~/components/EditableTextField'
import { showAddKnowledgeSourceDialog } from '~/features/knowledge-bases/components/knowledge-source/AddKnowledgeSource/AddKnowledgeSourceDialog'
import { WebPageSourceTable } from '~/features/knowledge-bases/components/knowledge-source/WebPageSourceTable'
import { useKnowledgeBase } from '~/features/knowledge-bases/hooks/useKnowledgeBase'
import { useRenameWebPageSource, useWebPageSource } from '~/features/knowledge-bases/hooks/useKnowledgeSource'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId, kbId, dsId } = Route.useParams()
  const { data: kb } = useKnowledgeBase({ workspaceId, botId, kbId })
  const { title } = useWebPageSource({ workspaceId, botId, kbId: kb.oldKbId ?? kbId, dsId })
  const { mutate: renameWebPageSource, isPending, isSuccess } = useRenameWebPageSource({ workspaceId, botId })

  return (
    <Page
      primaryActions={
        <Button
          className="h-full w-full md:w-fit"
          onClick={(e) => {
            e.stopPropagation()

            showAddKnowledgeSourceDialog({
              workspaceId,
              botId,
              kbId: kb.oldKbId ?? kbId,
              dsId,
              startStep: 'sync_website',
              hideBackArrow: true,
            })
          }}
        >
          <Plus />
          Add Pages
        </Button>
      }
      title={
        <div className="flex w-full gap-2">
          <Link to="/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId" params={{ workspaceId, botId, kbId }}>
            <Button variant="ghost" size="icon">
              <ArrowLeft />
            </Button>
          </Link>
          <EditableTextField
            defaultName={title}
            onEdit={(newName: string) => {
              renameWebPageSource(
                { workspaceId, botId, kbId: kb.oldKbId ?? kbId, dsId, name: newName },
                {
                  onSuccess: () => {
                    showSuccessToast(`Web page source has been successfully renamed to "${newName}"`)
                  },
                }
              )
            }}
            isPending={isPending}
            isSuccess={isSuccess}
            maxLength={64}
            showError
          />
        </div>
      }
    >
      <Boundary>
        <WebPageSourceTable
          workspaceId={workspaceId}
          botId={botId}
          kbId={kb.oldKbId ?? kbId}
          dsId={dsId}
          knowledgeBaseName={kb.name}
        />
      </Boundary>
    </Page>
  )
}
